export const KEY_REDUCER_SUPPORT = "support";
